import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import AnalyticsBase from '../AnalyticsBase';
import AnalyticsFilterBar from '../AnalyticsFilterBar';
import BreadcrumbNav from '../../nav/BreadcrumbNav';

import { initializeAnalytics } from '../../../state/reducer/analytics/actionCreators/initializeAnalytics';
import { ParamUrlBuilder } from '../../../lib/ParamUrlBuilder';
import * as DateUtils from '../../../lib/dateUtils';
import * as LibraryState from '../../../state/reducer/library/library';
import * as AnalyticsState from '../../../state/reducer/analytics/analytics';

import Console from '../../../lib/debug';

const PAGE_KEY = 'training-summary-team';

export class TrainingSummaryTeamViewClass extends Component {
    constructor(props) {
        super(props);
        LibraryState.fetchTeams();
    }

    componentDidUpdate(prevProps, prevState) {
        this.loadAnalytics();
    }

    loadAnalytics = () => {
        const dataParams = this.getDataParams();
        this.props.dispatch(initializeAnalytics(PAGE_KEY, dataParams));
    };

    getDataParams = () => {
        const searchParams = AnalyticsState.getSearchParams();

        let date = searchParams.date;
        if (!DateUtils.isValidDateString(date)) {
            date = moment();
            date = moment(date, DateUtils.CALENDAR_FORMAT);
        }

        let teamIds = parseInt(searchParams.team_ids, 10);
        if (!teamIds || typeof teamIds !== 'number') {
            teamIds = [];
        } else {
            teamIds = [teamIds];
        }

        let useMetric = parseInt(searchParams.use_metric, 10) === 1;
        if (searchParams.use_metric === undefined) {
            useMetric = this.props && this.props.useMetric;
        }

        return {
            team_ids: teamIds,
            date: moment(date).format('YYYY-MM-DD'),
            use_metric: useMetric ? 1 : 0
        };
    };

    setSearchParams = params => {
        const existingParams = AnalyticsState.getSearchParams();
        AnalyticsState.updateSearchParams({
            ...existingParams,
            ...params
        });
    };

    getSelectedId = () => {
        const params = this.getDataParams();
        if (params.team_ids.length === 1) {
            return params.team_ids[0];
        }

        return undefined;
    };

    getDate = () => {
        const dataParams = this.getDataParams();
        return moment(dataParams.date);
    };

    handleDateChange = date => {
        date = date.format(DateUtils.CALENDAR_FORMAT);
        this.setSearchParams({
            date
        });
    };

    handleTeamChange = (ev, selected) => {
        const team_ids =
            selected.suggestion.allOption === true
                ? []
                : [selected.suggestion.id];
        this.setSearchParams({
            team_ids
        });
    };

    handleUseMetricChange = useMetric => {
        this.setSearchParams({
            use_metric: useMetric ? 1 : 0
        });
    };

    onClick = (e, row, rowIndex) => {
        const dataParams = this.getDataParams();
        const paramUrlBuilder = new ParamUrlBuilder(
            '/analytics/training-summary-athlete/'
        );

        paramUrlBuilder.setUserId(row.user_id);
        if (moment().diff(dataParams.date, 'days') !== 0) {
            paramUrlBuilder.setEndDate(this.getDate());
        }
        paramUrlBuilder.setUseMetric(dataParams.use_metric);
        AnalyticsState.navigate(paramUrlBuilder.buildUrl());
    };

    getPageTitle = () => {
        let title =
            this.props.metaTree &&
            this.props.metaTree.instances &&
            this.props.metaTree.instances[PAGE_KEY] &&
            this.props.metaTree.instances[PAGE_KEY].title;
        if (title) {
            return title;
        }
        return 'Training Summary';
    };

    render() {
        Console.render('TrainingSummaryTeamView');
        const rowEvents = {
            onClick: this.onClick
        };

        const crumbs = [
            {
                displayString: 'Analytics',
                link: `/analytics`,
                editable: false
            },
            {
                displayString: this.getPageTitle(),
                link: null,
                editable: false
            }
        ];

        const dataParams = this.getDataParams();

        return (
            <div className="has-filter-bar">
                <BreadcrumbNav crumbs={crumbs} />
                <AnalyticsFilterBar
                    datePicker={{
                        date: this.getDate(),
                        onChange: this.handleDateChange
                    }}
                    teamSelector={{
                        selectedId: this.getSelectedId(),
                        onSelect: this.handleTeamChange,
                        allOptionText: 'All Athletes'
                    }}
                    useMetricSelector={{
                        useMetric: dataParams.use_metric,
                        onChange: this.handleUseMetricChange
                    }}
                />
                <AnalyticsBase rowEvents={rowEvents} />;
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        teams: state.library.teamsTree,
        metaTree: state.analytics.metaTree,
        useMetric: state.app.loggedInUser.use_metric
    };
};

export default connect(mapStateToProps)(TrainingSummaryTeamViewClass);



// WEBPACK FOOTER //
// ./src/view/analytics/training-summary/TrainingSummaryTeamView.jsx